let currentSlideIndex;
let inCallbackFired = false;
let currentSlideMomentId = 0
// let creditsMainTimeout
// let creditsLinesTimeout

export function nextSlideHook(newIndex) {
    
    currentSlideIndex = newIndex
    inCallbackFired = false
}



export function configAnimations({
    captions, 
    captionPlayMode, 
    slideIndex, 
    deviceType, 
    pauseDuration, 
    callback, 
    unicalClassName, 
    getHoverState = () => false, 
    pauseOnHover = false, 
    getAnimationIsActive = () => true,
    slideMomentId
}) {
    const unicClassName = unicalClassName ? `-${unicalClassName}` : ''
    // используя замыкание держу в переменной currentSlideMomentId актуальный id прокрутки слайда,
    // который каждый раз при прокрутке генерируется заново и равен Date.now()
    // для того, чтобы при переключении на следующий слайд countdown loop анимация прекращалась на ушедшем слайде,
    // ведь она всё равно начнётся заново, когда пользователь вернётся к слайду, на котором она была.
    // Иначе триггеры анимаций накладываются друг на друга.
    currentSlideMomentId = slideMomentId

    // slideIndex - ииндекс слайда в массиве слайдов
    let _captions = []
    // список классов по которым находятся капчи, которые нужно анимировать
    let captionsClassnames = []
    // коллекции map для контроля проигрывания анимации
    // если анимация проигралась, ставим true
    // textillate порою вызывает 2 раза callback на одной и той же капче, поэтому для контроля отыгранных капч используем контроллеры
    let showAllCaptionsController = new Map()
    let hideAllCaptionsController = new Map()
    let typeWritersMap = new Map()
    // коллекция кэпшнов для типа анимации с задержкой
    // если капшн появился и исчез, то ставим true - значит этот кэпшн разрешает смену слайда
    let delayTypeCaptionsController = new Map()

    // коллекция капч с анимацией появления
    let captionsWithAnimateIn = new Map()

    let captionsWaitForUnhover = new Set()
    let intervalIsOn = false
    captions.map((caption, index) => {
        
        if (caption.boxId === '') {
            // список классов по которым находятся капчи, которые нужно анимировать
            captionsClassnames.push(`caption-${slideIndex}-${caption.index}${unicClassName}`)
            caption.className = `caption-${slideIndex}-${caption.index}${unicClassName}`
            // помещаем только те капчи, которые нужно анимировать (которые не вложены в box)
            _captions.push(caption)
        }
        
    })
    // добавляем капчи в коллекции анимации появления скрытия 
    _captions.forEach((caption) => {

        if (caption.animationIn !== 'none') {
            captionsWithAnimateIn.set(caption.index, false)
        }
        
        showAllCaptionsController.set(caption.index, false)
            
        if (caption.animationOut !== 'none' || caption.animationIn === 'typing' || caption.animationIn.includes('countdown') || caption.animationIn.includes('credits')) {
        // if (caption.animationOut !== 'none' || caption.animationIn === 'typing') {
            hideAllCaptionsController.set(caption.index, false)
        }

        if (captionPlayMode === 'delay') {
            delayTypeCaptionsController.set(caption.index, false)
        }
    })


    // если есть капчи, которые не вложены в бокс (а они всегда есть, если капчи на слайде есть вообще), то начинаем проигрывать анимацию капч
    if (_captions.length > 0) {

        _captions.forEach((caption, captionIndex) => {

            if (caption.type === 'text') {

                if (caption.animationIn === 'typing') {
                    const slidesArray = document.getElementsByClassName(caption.className)
                    
                    for (let i = 0; i < slidesArray.length; i++) {
                        if (!slidesArray[i].parentElement.parentElement.parentElement.matches('.clone')) {
                            // коллекция Map ключ - индекс капчи, значение - анимация печати из библиотеки
                            typeWritersMap.set(
                                captionIndex,
                                new Typewriter(slidesArray[i], {
                                    wrapperClassName: 'typewriter',
                                    cursor: caption.typewriterCursor !== undefined ? caption.typewriterCursor : '|',
                                })
                            )
                        }
                    }
                } else if (caption.animationIn === 'countdownUp' || caption.animationIn === 'countdownDown') {
                    const captionElements = document.querySelectorAll('.' + caption.className)
                    for (let i = 0; i < captionElements.length; i++) {
                        // чтобы на второй итерации цикла слайдов элемент появился с текстом первой строки
                        const listElement = captionElements[i].querySelector('.countdown-list')
                        listElement.style.transition = 'none'
                        // listElement.style.transform = `translateY(0)`
                        // listElement.style.transform = `translate(0,0)`
                        listElement.style.top = 0
                        // setTransformY(listElement, 0)
                    }

                } else if (caption.animationIn.includes('countdownCube')) {

                } else if (caption.animationIn == 'stripes') {
                } else if (caption.animationIn == 'credits' || caption.animationIn == 'credits-forward') {
                
                } else {
                    // isOnlyAnimationOut = true, чтобы проигрывалась анимация исчезновения, если нет анимации появления
                    const isOnlyAnimationOut = caption.animationIn === 'none' && caption.animationOut !== 'none'
                    // const isOnlyAnimationOut = false
                    buildCaption(caption, captionIndex, isOnlyAnimationOut);
                }
            }
        });

        startAnimations();

    } else {
        setTimeout(() => {
            endAnimations()
        }, pauseDuration)
    }





    function buildCaption(caption, captionIndex, isOnlyAnimationOut = false) {
        let animationConfig = {
            loop: false,
            autoStart: isOnlyAnimationOut,
            // autoStart: (captionPlayMode === 'simultaneously' || isOnlyAnimationOut ),
            inEffects: [caption.animationIn],
            outEffects: [caption.animationOut],
            in: {
                effect: caption.animationIn,
                delayScale: 1.5,
                delay: 50,
                sync: (caption.animationModeIn === 'sync'),
                shuffle: (caption.animationModeIn === 'shuffle'),
                reverse: (caption.animationModeIn === 'reverse'),
                callback: () => inCallback(captionIndex),
            },
            out: {
                effect: caption.animationOut,
                delayScale: 1.5,
                delay: 50,
                sync: (caption.animationModeOut === 'sync'),
                shuffle: (caption.animationModeOut === 'shuffle'),
                reverse: (caption.animationModeOut === 'reverse'),
                callback: () => outCallback(captionIndex),
            },
            callback: () => {}
        };
        $('.' + caption.className).textillate(animationConfig);
        animationConfig = null
    }

    const slideHMTLElement = document.querySelector(`.slide-container-${slideIndex}:not(.clone)`) || document


    function startAnimations() {

        _captions.forEach((caption, captionIndex) => {
            if (caption.animationIn === 'none' || caption.animationIn.includes('countdown') || caption.animationIn === 'stripes' || caption.animationIn.includes('credits')) {
                // если нет анимации появления, то делаем видимым сразу
                $('.' + caption.className).css({ opacity: 1 });
            } else {
                // если есть анимация появления, то сначала скрываем капчу
                $('.' + caption.className).css({ opacity: 0 });
            }
            
        })
        switch (captionPlayMode) {

            case 'simultaneously':
                // если нет элементов с анимацией появления, то вызываем колбек, который идёт после завершения всех анимаций появления
                if (captionsWithAnimateIn.size === 0) {
                    inCallback(null)
                    return
                }

                _captions.forEach((caption, captionIndex) => {
                    // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                    if (unicClassName && !document.querySelector(`.${caption.className}`)) {
                        return
                    }

                    if (caption.animationIn === 'none') {
                        inCallback(captionIndex)
                        return
                    }
                    setTimeout(() => {
                        // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                        if (unicClassName && !document.querySelector(`.${caption.className}`)) {
                            return
                        }
                        // чтобы кнопка не мигала, когда после полного круга анимации показывается первый слайд добавил timeout
                        const timeoutDelay = (caption.type === 'button' && caption.delayIn < 100) ? 100 : 0
                        setTimeout(() => {
                            $('.' + caption.className).css({ opacity: 1 });
                        },timeoutDelay)

                        if (caption.type === 'text') {
    
                            if (caption.animationIn === 'typing') {
                                const typewriter = typeWritersMap.get(captionIndex);
                                const lastLine = caption.text[caption.text.length - 1]
                                caption.text.map((line, index) => {
                                    if (index != caption.text.length - 1) {
                                        typewriter.typeString(line)
                                            // .callFunction(() => {
                                            //     if (document.querySelector(`.${caption.className}`).classList.contains('preventAnimation')) {
                                            //         typewriter.stop()
                                            //     } 
                                            // })
                                            .callFunction(() => $('.' + caption.className).css({ opacity: 1 }))
                                            .pauseFor(caption.pauseBetweenLines)
                                            .deleteAll()
                                            // .start()
                                    } 
                                })
    
                                typewriter.typeString(lastLine).callFunction(() => inCallback(captionIndex))
                                typewriter.start()
                            
                            } else if (caption.animationIn === 'countdownUp' || caption.animationIn === 'countdownDown') {

                                // $('.' + caption.className).css({ opacity: 1 })
                                // const captionElement = $('.' + caption.className).get(0)
                                const captionElement = slideHMTLElement.querySelector('.' + caption.className)
                                if (captionElement.classList.contains('countdown-container')) {
                                    animateCountdown({
                                        captionElement, 
                                        callback: () => inCallback(captionIndex), 
                                        animationDirection: 'animationIn', 
                                        getAnimationIsActive, 
                                        isInBox: false,
                                        slideMomentId
                                    })
                                } else {
                                    inCallback(captionIndex)
                                }
    
                            } else if (caption.animationIn === 'countdownCube' || caption.animationIn === 'countdownCubeRev') {
                                // const captionElement = $('.' + caption.className).get(0)
                                const captionElement = slideHMTLElement.querySelector('.' + caption.className)
                                // console.log('start countdown cube simultaneously')
                                if (captionElement.classList.contains('countdown-container')) {
                                    animateCountdownCube({
                                        captionElement, 
                                        callback: () => inCallback(captionIndex), 
                                        animationDirection: 'animationIn', 
                                        getAnimationIsActive, 
                                        isInBox: false,
                                        slideMomentId
                                    })
                                } else {
                                    inCallback(captionIndex)
                                }
                            } else if (caption.animationIn == 'stripes') {
                            } else if (caption.animationIn == 'credits' || caption.animationIn == 'credits-forward') {
                                // const captionElement = $('.' + caption.className).get(0)
                                const captionElement = slideHMTLElement.querySelector('.' + caption.className)
                                try{
                                    if (captionElement.classList.contains('credits-container')) {
                                        animateCredits({
                                            captionElement, 
                                            callback: () => inCallback(captionIndex), 
                                            animationDirection: 'animationIn', 
                                            getAnimationIsActive, 
                                            isInBox: false,
                                            slideMomentId
                                        })
                                    } else {
                                        inCallback(captionIndex)
                                    }
                                } catch (e) {
                                  console.warn(e)
                                    inCallback(captionIndex)
                                }
                            } else {
                                $('.' + caption.className).textillate('in')
                            }
    
                        } else {
                            // поиск по классу, который содержит номер слайда, чтобы анимация не применялась к капчам с соседних слайдов
                            // в id вставить номер слайда нельзя, т.к. этот id используется в Draggable
                            const captionId = `.animate-${slideIndex}-${caption.index}`;
                            // const captionId = `#caption-${caption.index}`;
                            const animationInConfig = caption.animationIn
                            animateCSS(captionId, animationInConfig, caption.className, () => inCallback(captionIndex), unicClassName, 'animationIn', getAnimationIsActive, slideMomentId)
                        }
                    }, caption.delayIn)
                })
                break;

            case 'delay':


                _captions.forEach((caption, captionIndex) => {
                    if (caption.animationIn === 'none') {
                        $('.' + caption.className).css({ opacity: 1 });
                        // если анимации появления нет, то нет и отсрочки, 
                        // поэтому сразу вызываем колбек, идущий после завершения анимации появления
                        inCallback(captionIndex)
                    } else {

                        setTimeout(() => {
                            // чтобы кнопка не мигала, когда после полного круга анимации показывается первый слайд добавил timeout
                            const timeoutDelay = (caption.type === 'button' && caption.delayIn < 100) ? 100 : 0
                            setTimeout(() => {
                                $('.' + caption.className).css({ opacity: 1 });
                            },timeoutDelay)
    
                            // $('.' + caption.className).css({ opacity: 1 });
                            // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                            // if (document.querySelector(`.${caption.className}`).classList.contains('preventAnimation')) {
                            //     return
                            // }
                            if (unicClassName && !document.querySelector(`.${caption.className}`)) {
                                return
                            }
                            if (caption.type === 'text') {
    
                                if (caption.animationIn === 'typing') {
                                    const typewriter = typeWritersMap.get(captionIndex);
                                    const lastLine = caption.text[caption.text.length - 1]
                                    caption.text.map((line, index) => {
                                        if (index != caption.text.length - 1) {
                                            typewriter.typeString(line)
                                                .callFunction(() => $('.' + caption.className).css({ opacity: 1 }))
                                                .pauseFor(caption.pauseBetweenLines)
                                                .deleteAll()
                                                // .start()
                                        }
                                    })
    
                                    typewriter.typeString(lastLine).callFunction(() => inCallback(captionIndex))
                                    typewriter.start()

                                } else if (caption.animationIn === 'countdownUp' || caption.animationIn === 'countdownDown') {
                                    // $('.' + caption.className).css({ opacity: 1 })
                                    // const captionElement = $('.' + caption.className).get(0)
                                    const captionElement = slideHMTLElement.querySelector('.' + caption.className)
                                    if (captionElement.classList.contains('countdown-container')) {
                                        animateCountdown({
                                            captionElement, 
                                            callback: () => inCallback(captionIndex), 
                                            animationDirection: 'animationIn', 
                                            getAnimationIsActive, 
                                            isInBox: false,
                                            slideMomentId
                                        })
                                    } else {
                                        inCallback(captionIndex)
                                    }

                                } else if (caption.animationIn === 'countdownCube' || caption.animationIn === 'countdownCubeRev') {
                                    // $('.' + caption.className).css({ opacity: 1 })
                                    // const captionElement = $('.' + caption.className).get(0)
                                    const captionElement = slideHMTLElement.querySelector('.' + caption.className)
                                    if (captionElement.classList.contains('countdown-container')) {
                                        animateCountdownCube({
                                            captionElement, 
                                            callback: () => inCallback(captionIndex), 
                                            animationDirection: 'animationIn', 
                                            getAnimationIsActive, 
                                            isInBox: false,
                                            slideMomentId
                                        })
                                    } else {
                                        inCallback(captionIndex)
                                    }

                                } else if (caption.animationIn == 'stripes') {
                                } else if (caption.animationIn == 'credits' || caption.animationIn == 'credits-forward') {
                                    // const captionElement = $('.' + caption.className).get(0)
                                    const captionElement = slideHMTLElement.querySelector('.' + caption.className)
                                    try{
                                        if (captionElement.classList.contains('credits-container')) {
                                            animateCredits({
                                                captionElement, 
                                                callback: () => inCallback(captionIndex), 
                                                animationDirection: 'animationIn', 
                                                getAnimationIsActive, 
                                                isInBox: false,
                                                slideMomentId
                                            })
                                        } else {
                                            inCallback(captionIndex)
                                        }
                                    } catch (e) {
                                      console.warn(e)
                                        inCallback(captionIndex)
                                    }
                                } else {
                                    $('.' + caption.className).textillate('in')
                                }
    
                            } else {
                                const captionId = `.animate-${slideIndex}-${caption.index}`;
                                // const captionId = `#caption-${caption.index}`;
                                const animationInConfig = caption.animationIn
                                animateCSS(captionId, animationInConfig, caption.className, () => inCallback(captionIndex), unicClassName, 'animationIn', getAnimationIsActive, slideMomentId)
                            }
                        }, caption.delayIn)
                    }
                })

                break

            case 'oneByOne':
                // если нет элементов с анимацией появления, то вызываем колбек, который идёт после завершения всех анимаций появления
                if (captionsWithAnimateIn.size === 0) {
                    inCallback(null)
                    return
                }
                let i = 0
                let firstCaption = _captions[i]
                while (firstCaption && firstCaption.animationIn === 'none') {
                    // если у выбранной капчи нет анимации появления, то ставим в контроллере будто она проигралась
                    showAllCaptionsController.set(firstCaption.index, true)
                    firstCaption = _captions[++i]
                }
                
                // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                if (unicClassName && !document.querySelector(`.${firstCaption.className}`)) {
                    return
                }

                setTimeout(() => {

                    // $('.' + firstCaption.className).css({ opacity: 1 });
                    // чтобы кнопка не мигала, когда после полного круга анимации показывается первый слайд, добавил timeout
                    const timeoutDelay = (firstCaption.type === 'button' && firstCaption.delayIn < 100) ? 100 : 0
                    setTimeout(() => {
                        $('.' + firstCaption.className).css({ opacity: 1 });
                    },timeoutDelay)
    
    
                    if (firstCaption.type === 'text') {
                        if (firstCaption.animationIn === 'typing') {
                            const typewriter = typeWritersMap.get(firstCaption.index);
                            const lastLine = firstCaption.text[firstCaption.text.length - 1]
                            
                            firstCaption.text.map((line, index) => {
                                
                                if (index != firstCaption.text.length - 1) {
                                    typewriter.typeString(line)
                                        .callFunction(() => $('.' + firstCaption.className).css({ opacity: 1 }))
                                        .pauseFor(firstCaption.pauseBetweenLines)
                                        .deleteAll()
                                        // .start()
                                } 
                            })
    
                            typewriter.typeString(lastLine).callFunction(() => inCallback(i))
                            typewriter.start()

                        } else if (firstCaption.animationIn === 'countdownUp' || firstCaption.animationIn === 'countdownDown') {
                            // const captionElement = $('.' + firstCaption.className).get(0)
                            const captionElement = slideHMTLElement.querySelector('.' + firstCaption.className)
                            try{
                                if (captionElement.classList.contains('countdown-container')) {
                                    animateCountdown({
                                        captionElement, 
                                        callback: () => inCallback(i), 
                                        animationDirection: 'animationIn', 
                                        getAnimationIsActive, 
                                        isInBox: false,
                                        slideMomentId
                                    })
                                } else {
                                    inCallback(i)
                                }
                            } catch (e) {
                                console.warn(e)
                                inCallback(i)
                            }
                        } else if (firstCaption.animationIn === 'countdownCube' || firstCaption.animationIn === 'countdownCubeRev') {
                            // const captionElement = $('.' + firstCaption.className).get(0)
                            const captionElement = slideHMTLElement.querySelector('.' + firstCaption.className)
                            try{
                                if (captionElement.classList.contains('countdown-container')) {
                                    animateCountdownCube({
                                        captionElement, 
                                        callback: () => inCallback(i), 
                                        animationDirection: 'animationIn', 
                                        getAnimationIsActive, 
                                        isInBox: false,
                                        slideMomentId
                                    })
                                } else {
                                    inCallback(i)
                                }
                            } catch (e) {
                                console.warn(e)
                                inCallback(i)
                            }
                        } else if (firstCaption.animationIn == 'stripes') {
                            
                        } else if (firstCaption.animationIn == 'credits' || firstCaption.animationIn == 'credits-forward') {
                            // const captionElement = $('.' + firstCaption.className).get(0)
                            const captionElement = slideHMTLElement.querySelector('.' + firstCaption.className)
                            try{
                                if (captionElement.classList.contains('credits-container')) {
                                    animateCredits({
                                        captionElement, 
                                        callback: () => inCallback(i), 
                                        animationDirection: 'animationIn', 
                                        getAnimationIsActive, 
                                        isInBox: false,
                                        slideMomentId
                                    })
                                } else {
                                    inCallback(i)
                                }
                            } catch (e) {
                                console.warn(e)
                                inCallback(i)
                            }
                        } else {
                            $('.' + firstCaption.className).textillate('in')
                        }
                    } else {
                        const captionId = `.animate-${slideIndex}-${firstCaption.index}`;
                        // const captionId = `#caption-${firstCaption.index}`;
                        const animationInConfig = firstCaption.animationIn
                        animateCSS(captionId, animationInConfig, firstCaption.className, () => inCallback(i), unicClassName, 'animationIn', getAnimationIsActive, slideMomentId)
                    }
                }, firstCaption.delayIn)
                break;
        }
    }

    // вызывается после завершения анимации появления
    function inCallback(captionIndex) {
        // если на слайдер навели курсор, то анимация капч останавливается после их появления
        // капчи не начнут исчезать, пока курсор не уйдёт
        // ловим каждую капчу на входе в функцию, чтобы потом её с этого же места запустить
        if (pauseOnHover && getHoverState() && captionPlayMode !== 'oneByOne') {
            captionsWaitForUnhover.add(captionIndex)
            
            if (!intervalIsOn) {
                // чтобы не запускать несколько интервалов, ставим флаг, что он уже запущен
                intervalIsOn = true
                let checkHoverInterval = setInterval(() => {
                    // console.log('interval')
                    // если убрали курсор со слайдера, останавливаем интервал и запускаем функцию по новой
                    if (!getHoverState()) {
                        clearInterval(checkHoverInterval)
                        intervalIsOn = false
                        captionsWaitForUnhover.forEach((index) => {
                            inCallback(index)
                        })
                    }
                }, 500)
            }
            return
        }



        inCallbackFired = true
        let caption = _captions[captionIndex]
        if (currentSlideIndex === slideIndex) {
            // если значение у индекса false, то ставим true, т.к. анимация появленя проигралась
            // если анимации появления нет ни у одного элемента, то проверку не делаем
            if ((caption && !showAllCaptionsController.get(caption.index) && showAllCaptionsController.has(caption.index)) || captionsWithAnimateIn.size === 0 ) {
                // по умолчанию вся анимация проигралась
                let allCaptionShowed = true
                // если анимация появления есть у какого либо элемента, то проверяем чтобы все анимации появления проигрались
                if (captionsWithAnimateIn.size !== 0) {
                    showAllCaptionsController.set(caption.index, true) 
                    // если при обходе контроллера находим анимацию, которая не проигралась, то не пускаем дальше
                    for (const value of showAllCaptionsController.values()) {
                        if (value === false) {
                            allCaptionShowed = false 
                            break
                        }
                    }
                }
                // if (allCaptionShowed) {
                //     console.log('всё проигралось');
                // }

                switch (captionPlayMode) {
                    case 'simultaneously':
                        if (allCaptionShowed) {
                            setTimeout(() => {
                                // если нет элементов с анимацией исчезновения, то вызываем колбек, 
                                // который идёт после завершения всех анимаций исчезновения
                                if (hideAllCaptionsController.size === 0) {
                                    outCallback(null)
                                    return
                                }
                                _captions.forEach((caption, captionIndex) => {
                                    // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                                    if (unicClassName && !document.querySelector(`.${caption.className}`)) {
                                        return
                                    }
                                    if (caption.animationOut === 'none' && caption.animationIn !== 'typing' && caption.animationIn !== 'countdownUp' && caption.animationIn !== 'countdownDown') {
                                    // if (caption.animationOut === 'none' && caption.animationIn !== 'typing') {
                                        outCallback(captionIndex)
                                        return
                                    }

                                    setTimeout(() => {
                                        if (unicClassName && !document.querySelector(`.${caption.className}`)) {
                                            return
                                        }
                                        if (caption.type === 'text') {
                                            if (caption.animationIn === 'typing') {
                                                typeWritersMap.get(captionIndex).deleteAll().callFunction(() => outCallback(captionIndex)).start()

                                            } else if (caption.animationIn.includes('countdown')) {
                                                outCallback(captionIndex)
                                            } else if (caption.animationIn == 'stripes') {
                                            } else if (caption.animationIn == 'credits' || caption.animationIn == 'credits-forward') {
                                                outCallback(captionIndex)
                                            } else {
                                                // если не было анимации появления, то для того, чтобы textillate не мешал отображать текст
                                                // добавлен был класс showTextAnyway
                                                // если мы начинаем проигрывать анимацию исчезновения, то этот класс надо убрать
                                                $('.' + caption.className).textillate('out');
                                                $('.' + caption.className).removeClass("showTextAnyway");
                                            }
                                            
                                        } else {
                                            const captionId = `.animate-${slideIndex}-${caption.index}`;
                                            // const captionId = `#caption-${caption.index}`;
                                            const animationOutConfig = caption.animationOut
                                            animateCSS(captionId, animationOutConfig, caption.className, () => outCallback(captionIndex), unicClassName, 'animationOut', getAnimationIsActive, slideMomentId)
                                        }
                                    },caption.delayOut)
                                })
                            }, pauseDuration);

                        }
                        break;

                    case 'delay':
                        
                        if (caption.animationOut !== 'none' || caption.animationIn === 'typing') {
                            setTimeout(() => {
                                // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                                // if (document.querySelector(`.${caption.className}`).classList.contains('preventAnimation')) {
                                //     return
                                // }
                                if (unicClassName && !document.querySelector(`.${caption.className}`)) {
                                    return
                                }
                                if (caption.type === 'text') {
                                    if (caption.animationIn === 'typing') {
                                        typeWritersMap.get(captionIndex).deleteAll().callFunction(() => outCallback(captionIndex)).start()

                                    } else if (caption.animationIn.includes('countdown')) {
                                        outCallback(captionIndex)
                                    } else if (caption.animationIn == 'stripes') {
                                    } else if (caption.animationIn == 'credits' || caption.animationIn == 'credits-forward') {
                                        outCallback(captionIndex)
                                    }  else {
                                        // если не было анимации появления, то для того, чтобы textillate не мешал отображать текст
                                        // добавлен был класс showTextAnyway
                                        // если мы начинаем проигрывать анимацию исчезновения, то этот класс надо убрать
                                        $('.' + caption.className).textillate('out');
                                        setTimeout(() => {
                                            // если у капчи нет анимации появления, то для того, чтобы показать капчу в приезжающем слайде сразу
                                            // а не только когда начнётся инициализация анимаии, добавляем класс showTextAnyway
                                            // когда его убираем, то анимация исчезновения еще не добавила свой класс к капче и букв не видно
                                            //  поэтому чтобы не было мигания текста задерживаем убирание класса, показывающего текст
                                            $('.' + caption.className).removeClass("showTextAnyway");
                                        },100)
                                    }
                                } else {
                                    const captionId = `.animate-${slideIndex}-${caption.index}`;
                                    // const captionId = `#caption-${caption.index}`;
                                    const animationOutConfig = caption.animationOut
                                    animateCSS(captionId, animationOutConfig, caption.className, () => outCallback(captionIndex), unicClassName, 'animationOut', getAnimationIsActive, slideMomentId)
                                }
                            }, caption.delayOut + pauseDuration);
                        } else {
                            // если нет анимации исчезновения, то сразу вызываем колбек, который идёт после завершения анимации исчезновения
                            setTimeout(() => {
                                outCallback(captionIndex)
                            }, pauseDuration);
                        }

                        break;

                    case 'oneByOne':
                        if (allCaptionShowed) {
                            // момент, когда все капчи появились
                            allCaptionShowedOneByOne()
                            
                        } else {
                            // не все капчи появились
                            let nextCaption = _captions[++captionIndex]
                            if (!nextCaption) {
                                allCaptionShowedOneByOne()
                                return
                            }
                            // ищем следующую капчу с анимацией появления
                            while(nextCaption && nextCaption.animationIn === 'none') {
                                // если у выбранной капчи нет анимации появления, то ставим в контроллере будто она проигралась
                                showAllCaptionsController.set(nextCaption.index, true)
                                nextCaption = _captions[++captionIndex]
                                // если нет анимации появления у последнего элемента, то вызываем функцию, которая переходит к анимации исчезновения
                                if (!nextCaption) {
                                    allCaptionShowedOneByOne()
                                    return
                                }
                            }
                            // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                            if (unicClassName && !document.querySelector(`.${nextCaption.className}`)) {
                                return
                            }
                            
                            setTimeout(() => {
                                // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                                if (unicClassName && !document.querySelector(`.${nextCaption.className}`)) {
                                    return
                                }
                                $('.' + nextCaption.className).css({ opacity: 1 });
    
                                if (nextCaption.type === 'text') {
                                    if (nextCaption.animationIn === 'typing') {
                                        const typewriter = typeWritersMap.get(captionIndex);
                                        const lastLine = nextCaption.text[nextCaption.text.length - 1]
                                        nextCaption.text.map((line, index) => {
                                            if (index != nextCaption.text.length - 1) {
                                                typewriter.typeString(line)
                                                    .callFunction(() => $('.' + nextCaption.className).css({ opacity: 1 }))
                                                    .pauseFor(nextCaption.pauseBetweenLines)
                                                    .deleteAll()
                                            }
                                        })
                                        typewriter.typeString(lastLine).callFunction(() => inCallback(captionIndex))
                                        typewriter.start()

                                    } else if (nextCaption.animationIn === 'countdownUp' || nextCaption.animationIn === 'countdownDown') {
                                        // const captionElement = $('.' + nextCaption.className).get(0)
                                        const captionElement = slideHMTLElement.querySelector('.' + nextCaption.className)
                                        if (captionElement.classList.contains('countdown-container')) {
                                            animateCountdown({
                                                captionElement, 
                                                callback: () => inCallback(captionIndex), 
                                                animationDirection: 'animationIn', 
                                                getAnimationIsActive, 
                                                isInBox: false,
                                                slideMomentId
                                            })
                                        } else {
                                            inCallback(captionIndex)
                                        }
                                    } else if (nextCaption.animationIn === 'countdownCube' || nextCaption.animationIn === 'countdownCubeRev') {
                                        // const captionElement = $('.' + nextCaption.className).get(0)
                                        const captionElement = slideHMTLElement.querySelector('.' + nextCaption.className)
                                        if (captionElement.classList.contains('countdown-container')) {
                                            animateCountdownCube({
                                                captionElement, 
                                                callback: () => inCallback(captionIndex), 
                                                animationDirection: 'animationIn', 
                                                getAnimationIsActive, 
                                                isInBox: false,
                                                slideMomentId
                                            })
                                        } else {
                                            inCallback(captionIndex)
                                        }
                                    } else if (nextCaption.animationIn == 'stripes') {
                                    } else if (nextCaption.animationIn == 'credits' || nextCaption.animationIn == 'credits-forward') {
                                        // const captionElement = $('.' + nextCaption.className).get(0)
                                        const captionElement = slideHMTLElement.querySelector('.' + nextCaption.className)
                                        if (captionElement.classList.contains('credits-container')) {
                                            animateCredits({
                                                captionElement, 
                                                callback: () => inCallback(captionIndex), 
                                                animationDirection: 'animationIn', 
                                                getAnimationIsActive, 
                                                isInBox: false,
                                                slideMomentId
                                            })
                                        } else {
                                            inCallback(captionIndex)
                                        }
                                    } else {
                                        $('.' + nextCaption.className).textillate('in');
                                    }
                                } else {
                                    const captionId = `.animate-${slideIndex}-${nextCaption.index}`;
                                    // const captionId = `#caption-${nextCaption.index}`;
                                    const animationInConfig = nextCaption.animationIn
                                    animateCSS(captionId, animationInConfig, nextCaption.className, () => inCallback(captionIndex), unicClassName, 'animationIn', getAnimationIsActive, slideMomentId)
                                }
                            }, nextCaption.delayIn)
                        }
                           break;
                }
            } else {
                // console.log('STOP CAPTION лишний раз хотела играться', caption.index);
            }
        }
    }

    // запускаем когда все капчи появились в моде One by one
    function allCaptionShowedOneByOne() {
        // console.log('allCaptionShowedOneByOne')
        // предотвращаю анимацию исчезновения капч, если курсор над слайдером
        if (pauseOnHover && getHoverState()) {
            let checkHoverInterval = setInterval(() => {
                // console.log('interval')
                if (!getHoverState()) {
                    // console.log('clearInterval');
                    clearInterval(checkHoverInterval)
                    allCaptionShowedOneByOne()
                }
            }, 500)
            return
        }
        let i = 0
        let firstCaption = _captions[i]
        
        setTimeout(() => {
            if (hideAllCaptionsController.size === 0) {
                // если нет анимации исчезновения ни у одной капчи,
                // то сразу вызываем коллбек, который срабатывает после всех анимация
                outCallback(null)
                return
            }
            // поиск первой капчи с анимацией исчезновения
            while(firstCaption.animationOut === 'none' && firstCaption.animationIn !== 'typing' && firstCaption.animationIn !== 'countdownUp' && firstCaption.animationIn !== 'countdownDown' && firstCaption.animationIn !== 'credits' && firstCaption.animationIn !== 'credits-forward') {
                firstCaption = _captions[++i]
            }

            // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
            if (unicClassName && !document.querySelector(`.${firstCaption.className}`)) {
                return
            }

            // тут отыгрывает анимация только первой капчи, остальные - в outCallback 
            setTimeout(() => {
                // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                if (unicClassName && !document.querySelector(`.${firstCaption.className}`)) {
                    return
                }

                if (firstCaption.type === 'text') {
                    if (firstCaption.animationIn === 'typing') {
                        const typewriter = typeWritersMap.get(i);
                        typewriter.deleteAll().callFunction(() => outCallback(i)).start()
                    
                    } else if (firstCaption.animationIn.includes('countdown')) {
                        outCallback(i)
                    } else if (firstCaption.animationIn == 'stripes') {
                    } else if (firstCaption.animationIn == 'credits' || firstCaption.animationIn == 'credits-forward') {
                        outCallback(i)
                    } else {
                        $('.' + firstCaption.className).textillate('out')
                        setTimeout(() => {
                            // если у капчи нет анимации появления, то для того, чтобы показать капчу в приезжающем слайде сразу
                            // а не только когда начнётся инициализация анимаци, добавляем класс showTextAnyway
                            // когда его убираем, то анимация исчезновения еще не добавила свой класс к капче и букв не видно
                            //  поэтому чтобы не было мигания текста задерживаем убирание класса, показывающего текст
                            $('.' + firstCaption.className).removeClass("showTextAnyway");
                        },100)
                    }
                } else {
                    const captionId = `.animate-${slideIndex}-${firstCaption.index}`;
                    // const captionId = `#caption-${firstCaption.index}`;
                    const animationOutConfig = firstCaption.animationOut
                    animateCSS(captionId, animationOutConfig, firstCaption.className, () => outCallback(i), unicClassName, 'animationOut', getAnimationIsActive, slideMomentId)
                }
            }, firstCaption.delayOut)
        }, pauseDuration)
    }

    // вызываетсся, когда сработала анимация исчезновения
    function outCallback(captionIndex) {
        let allCaptionHided = true
        if (captionPlayMode === 'delay') {
            let caption = _captions[captionIndex]
            //  если у капчи есть анимация исчезновения, то после исчезновения скрываем капчу
            if (caption.animationOut !== 'none' || caption.animationIn === 'typing') {
                // console.log('OUT CALL 0')
                $('.' + caption.className).css({ opacity: 0 });
            }

            delayTypeCaptionsController.set(caption.index, true)
            for (const value of delayTypeCaptionsController.values()) {
                if (value === false) {
                    allCaptionHided = false 
                    break
                }
            }
        } 
        else if (hideAllCaptionsController && hideAllCaptionsController.size !== 0) {

            // если анимация с данным индексом уже проигралась, то не запускаем функцию
            let caption = _captions[captionIndex]
            if (hideAllCaptionsController.get(caption.index)) return

            // если есть анимация с данным индексом и она не проигралась (false)
            // то проигрываем её и ставим ей true (чтобы пометить как проигранную) 
            if (!hideAllCaptionsController.has(caption.index)) return
            hideAllCaptionsController.set(caption.index, true)


            for (const value of hideAllCaptionsController.values()) {
                if (value === false) {
                    allCaptionHided = false 
                    break
                }
            }
            // countdown не должен исчезать, как если бы у него не было анимации out
            if (
                !caption.animationIn.includes('countdown')
                && !caption.animationIn.includes('credits')
                && caption.animationIn !== 'stripes') {
                $('.' + caption.className).css({ opacity: 0 });
            }
            
        }

        if (currentSlideIndex === slideIndex && inCallbackFired) {

            switch (captionPlayMode) {
                case 'simultaneously':
                    if (allCaptionHided) {
                        endAnimations()
                    }
                    break;

                case 'delay':
                    if (allCaptionHided) {
                        endAnimations()
                    }
                    break;

                case 'oneByOne':
                    if (allCaptionHided) {
                        endAnimations()
                    } else {
                        // получаем следующий капшн
                        let nextCaption = _captions[++captionIndex]
                        while(nextCaption && nextCaption.animationOut === 'none' && nextCaption.animationIn !== 'typing' && nextCaption.animationIn !== 'countdownUp' && nextCaption.animationIn !== 'countdownDown' && nextCaption.animationIn !== 'credits' && nextCaption.animationIn !== 'credits-forward') {
                            // если последний капшн без анимации, то заканчиваем анимацию сразу
                            if ( (_captions.length - 1) === captionIndex) {
                                captionIndex = null
                                endAnimations()
                                return;
                            } else {
                                nextCaption = _captions[++captionIndex]
                            }
                        }

                        if (!nextCaption) {
                            captionIndex = null
                            endAnimations()
                            return;
                        }
                        // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                        if (unicClassName && !document.querySelector(`.${nextCaption.className}`)) {
                            return
                        }
                        
                        setTimeout(() => {
                            // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
                            if (unicClassName && !document.querySelector(`.${nextCaption.className}`)) {
                                return
                            }

                            if (nextCaption.type === 'text') {
                                if (nextCaption.animationIn === 'typing') {
                                    const typewriter = typeWritersMap.get(captionIndex);
                                    typewriter.deleteAll().callFunction(() => outCallback(captionIndex)).start()
                                } else if (nextCaption.animationIn.includes('countdown')) {
                                    outCallback(captionIndex)
                                } else if (nextCaption.animationIn == 'stripes') {
                                } else if (nextCaption.animationIn == 'credits' || nextCaption.animationIn == 'credits-forward') {
                                    outCallback(captionIndex)
                                } else {
                                    $('.' + nextCaption.className).textillate('out');
                                    setTimeout(() => {
                                        // если у капчи нет анимации появления, то для того, чтобы показать капчу в приезжающем слайде сразу
                                        // а не только когда начнётся инициализация анимаии, добавляем класс showTextAnyway
                                        // когда его убираем, то анимация исчезновения еще не добавила свой класс к капче и букв не видно
                                        //  поэтому чтобы не было мигания текста задерживаем убирание класса, показывающего текст
                                        $('.' + nextCaption.className).removeClass("showTextAnyway");
                                    },100)
                                }

                            } else {
                                const captionId = `.animate-${slideIndex}-${nextCaption.index}`;
                                // const captionId = `#caption-${nextCaption.index}`;
                                const animationOutConfig = nextCaption.animationOut
                                
                                animateCSS(captionId, animationOutConfig, nextCaption.className, () => outCallback(captionIndex), unicClassName, 'animationOut', getAnimationIsActive, slideMomentId)
                            }
                        }, nextCaption.delayOut)
                    }
                    break;
            }
        }
    }

    function endAnimations() {

        if (typeof callback === 'function') {
            // textillate порою вызывает 2 раза callback на одной и той же капче, поэтому для контроля отыгранных капч используем контроллеры
            // обнуляем все контроллеры в состояние, когда ещё ничего не проиграно
            for (const key of captionsWithAnimateIn.keys()) {
                captionsWithAnimateIn.set(key, false)
            }
            for (const key of showAllCaptionsController.keys()) {
                showAllCaptionsController.set(key, false)
            }
            for (const key of hideAllCaptionsController.keys()) {
                hideAllCaptionsController.set(key, false)
            }
            for (const key of delayTypeCaptionsController.keys()) {
                delayTypeCaptionsController.set(key, false)
            }
            
            callback(slideIndex)
        }
        
    }

}


function animateCSS(element, animationConfig, captionClassName, callback, unicClassName, animationDirection, getAnimationIsActive, slideMomentId) {
    // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
    if (unicClassName && !document.querySelector(`.${captionClassName}`)) {
        // console.log('animateCSS return')
        return
    } 

    let node = document.querySelectorAll(element)

    let visibleNodeElement

    for (let i = 0; i < node.length; i++) {
        if (!node[i].parentElement.parentElement.matches('.clone')) {
            visibleNodeElement = node[i]
        }
    }

    let handleAnimationEnd = () => {
        visibleNodeElement.classList.remove(animationConfig)
        visibleNodeElement.removeEventListener('animationend', handleAnimationEnd)
        if (unicClassName && !document.querySelector(`.${captionClassName}`)) {
            return
        } 

        // запускается анимация внутренних элементов с анимацией countdown
        const innerCountdownElements = visibleNodeElement.querySelectorAll('.countdown-container:not(.cube)')
        const innerCountdownElementsCube = visibleNodeElement.querySelectorAll('.countdown-container.cube')
        const innerCountdownElementsCredits = visibleNodeElement.querySelectorAll('.credits-container')

        let callbackCountReturned = 0
        const innerAnimationElementsLength = innerCountdownElements.length
        const innerAnimationCubeElementsLength = innerCountdownElementsCube.length
        const innerAnimationCreditsElementsLength = innerCountdownElementsCredits.length

        // получить колбеки о завершении всех внутренних анимаций
        let getCallbacks = () => {
            callbackCountReturned++
            // если все внутренние анимации завершились, то отправляем колбек, что и анимация этого бокса завершилась
            if (callbackCountReturned >= innerAnimationElementsLength + innerAnimationCubeElementsLength + innerAnimationCreditsElementsLength) {
                callback()
            }
        }
        if (innerAnimationElementsLength) {
            for (let i = 0; i < innerAnimationElementsLength; i++) {
                animateCountdown({
                    captionElement: innerCountdownElements[i], 
                    callback: () => getCallbacks(), 
                    animationDirection, 
                    getAnimationIsActive, 
                    isInBox: true,
                    slideMomentId
                })
            }
            
        }
        if (innerAnimationCubeElementsLength) {
            for (let i = 0; i < innerAnimationCubeElementsLength; i++) {
                animateCountdownCube({
                    captionElement: innerCountdownElementsCube[i], 
                    callback: () => getCallbacks(), 
                    animationDirection, 
                    getAnimationIsActive, 
                    isInBox: true,
                    slideMomentId
                })
            }
        } 
        if (innerAnimationCreditsElementsLength) {
            for (let i = 0; i < innerAnimationCreditsElementsLength; i++) {
                animateCredits({
                    captionElement: innerCountdownElementsCredits[i], 
                    callback: () => getCallbacks(), 
                    animationDirection, 
                    getAnimationIsActive, 
                    isInBox: true,
                    slideMomentId
                })
            }
        } 
        if (!innerAnimationElementsLength && !innerAnimationCubeElementsLength && !innerAnimationCreditsElementsLength) {
            if (typeof callback === 'function') {
                callback()
            } else {
                console.error('callback() is not a function')
            }
        }

        handleAnimationEnd = null
    }

    visibleNodeElement.classList.add(animationConfig)
    visibleNodeElement.addEventListener('animationend', handleAnimationEnd)

}

function animateCountdown({captionElement, callback, animationDirection, getAnimationIsActive = () => true, isInBox, slideMomentId}) {
    const constantPauseBetweenLines = 400
    const constantChangeTransitionTime = 50
    
    let pauseBetweenLines = captionElement.getAttribute('data-pauseBetweenLines') || 0
    // если капча находится вне бокса, то delayIn уже отсчитался при вызове текущей функции
    const delayIn = isInBox ? captionElement.getAttribute('data-delayIn') : 0
    // const delayOut = isInBox ? captionElement.getAttribute('data-delayOut') : constantPauseBetweenLines
    const delayOut = isInBox ? 0 : constantPauseBetweenLines
    const isLoop = captionElement.getAttribute('data-loop') === 'true'
    const isDownDirection = captionElement.getAttribute('data-direction') === 'down'
    // список
    const listElement = captionElement.querySelector('.countdown-list')

    // после анимации исчезновения переставляем список в первоначальное положение
    if (animationDirection === 'animationOut') {
        listElement.style.transition = 'none'
        listElement.style.top = 0
        if (typeof callback === 'function') {
            callback()
        } else {
            console.error('callback() is not a function')
        }
        return
    }
    const directionSign = isDownDirection ? 1 : -1

    // элементы списка
    const listItemElement = listElement.querySelectorAll('.contdown-item')
    const itemCount = listItemElement.length
    const height = listElement.getBoundingClientRect().height
    let currentLine = 0

    // если анимация зациклена, то добавляю в конец списка певрый элемент, чтобы был красивый переход между циклами
    if (isLoop) {
        let clonedFirstElem = listItemElement[0].cloneNode(true)
        listElement.append(clonedFirstElem)
    }
    setTimeout(() => {
        
        listElement.style.transition = ``
        changeCountdownItem(currentLine)
    },+delayIn + constantChangeTransitionTime)

    function changeCountdownItem(currentLine, minusMS = 0) {
        // если слайд переключился, а анимация предназначения для предыдущего слайда, то останавливаем её
        if (slideMomentId !== currentSlideMomentId) return
        // проверка, воспроизводится ли превью, чтобы прекратить цикл в случае с loop = true
        if (!getAnimationIsActive()) return
        listElement.style.top = currentLine * directionSign * height + 'px'

        currentLine++
        if (currentLine < itemCount) {
            setTimeout(() => {
                changeCountdownItem(currentLine)
            }, +pauseBetweenLines + constantPauseBetweenLines - minusMS)
        } else {
            if (isLoop) {
                setTimeout(() => {
                    listElement.style.top = currentLine * directionSign * height + 'px'
                    setTimeout(() => {
                        listElement.style.transition = 'none'
                        listElement.style.top = 0

                        setTimeout(() => {
                            currentLine = 0
                            listElement.style.transition = ''
                            changeCountdownItem(currentLine, constantPauseBetweenLines + constantChangeTransitionTime)
                        },constantChangeTransitionTime) // min 20ms
                    }, constantPauseBetweenLines)

                }, +pauseBetweenLines + constantPauseBetweenLines)
                
            } else {
                setTimeout(() => {
                    if (typeof callback === 'function') {
                        callback()
                    } else {
                        console.error('callback() is not a function')
                    }
                },+delayOut)
            }
        }
    }
}


function animateCountdownCube({captionElement, callback, animationDirection, getAnimationIsActive = () => true, isInBox, slideMomentId}) {
    const constantPauseBetweenLines = 400
    const constantChangeTransitionTime = 50
    // console.log('animateCountdownCube')
    let pauseBetweenLines = captionElement.getAttribute('data-pauseBetweenLines') || 0
    // если капча находится вне бокса, то delayIn уже отсчитался при вызове текущей функции
    const delayIn = isInBox ? captionElement.getAttribute('data-delayIn') : 0
    // const delayOut = isInBox ? captionElement.getAttribute('data-delayOut') : constantPauseBetweenLines
    const delayOut = isInBox ? 0 : constantPauseBetweenLines
    const isLoop = captionElement.getAttribute('data-loop') === 'true'
    const isDownDirection = captionElement.getAttribute('data-direction') === 'cube-rev'
    // список
    const listElement = captionElement.querySelector('.countdown-list')
    // console.log('start animateCountdownCube')
    // после анимации исчезновения переставляем список в первоначальное положение
    if (animationDirection === 'animationOut') {
        listElement.style.transition = 'none'
        listElement.style.top = 0
        if (typeof callback === 'function') {
            callback()
        } else {
            console.error('callback() is not a function')
        }
        return
    }
    let maxHeight = 0
    
    const directionSign = isDownDirection ? 1 : -1
    // const directionSign = 1

    // элементы списка
    const listItemElement = listElement.querySelectorAll('.contdown-item')
    for (let item of listItemElement) {
        item.offsetHeight > maxHeight ? maxHeight = item.offsetHeight : null
    }
    // console.log('max cube Height', maxHeight)
    // console.log('listElement', listElement)
    listElement.style.transformOrigin = `${maxHeight / 2}px ${maxHeight / 2}px 0`
    for (let [index, item] of listItemElement.entries()) {
        item.style.transform = `translateY(-50%) rotateX(${-directionSign * index * 90}deg) translateZ(${maxHeight / 2}px)`
    }
    const itemCount = listItemElement.length
    if (itemCount < 2) {
        callback()
        return
    }
    const height = listElement.getBoundingClientRect().height
    let currentLine = 0
    let clonedFirstElem
    // если анимация зациклена, то добавляю в конец списка певрый элемент, чтобы был красивый переход между циклами
    if (isLoop) {
        clonedFirstElem = listItemElement[0].cloneNode(true)
        const translateZClone = parseInt(clonedFirstElem.getAttribute('data-translate'))
        clonedFirstElem.style.transform = `translateY(-50%) rotateX(${listItemElement.length * -directionSign * 90}deg) translateZ(${maxHeight / 2}px) `
        clonedFirstElem.style.visibility = 'hidden'
        clonedFirstElem.style.top = '50%'
        listElement.append(clonedFirstElem)
    }
    listItemElement[currentLine].style.visibility = 'visible'
    listItemElement[currentLine + 1].style.visibility = 'visible'
    setTimeout(() => {
        
        listElement.style.transition = ``
        changeCountdownItem(currentLine)
    },+delayIn + constantChangeTransitionTime)

    function changeCountdownItem(currentLine, minusMS = 0) {
        // console.log('change countdown item cube')
        // если слайд переключился, а анимация предназначения для предыдущего слайда, то останавливаем её
        if (slideMomentId !== currentSlideMomentId) return
        // проверка, воспроизводится ли превью, чтобы прекратить цикл в случае с loop = true
        if (!getAnimationIsActive()) return
        listElement.style.transform = `rotateX(${currentLine * directionSign * 90}deg)`
        if (currentLine > 1) {
            listItemElement[currentLine - 2].style.visibility = ''
        }
        listItemElement[currentLine].style.visibility = 'visible'
        currentLine++
        if (currentLine < itemCount) {
            setTimeout(() => {
                
                changeCountdownItem(currentLine)
            }, +pauseBetweenLines + constantPauseBetweenLines - minusMS)
        } else {
            if (isLoop) {
                setTimeout(() => {
                    clonedFirstElem.style.visibility = 'visible'
                    listElement.style.transform = `rotateX(${currentLine * directionSign * 90}deg)`
                    setTimeout(() => {
                        listElement.style.transition = 'none'
                        clonedFirstElem.style.visibility = ''
                        listElement.style.transform = `rotateX(${0}deg)`
                        for (let item of listItemElement) {
                            item.style.visibility = ''
                        }
                        listItemElement[0].style.visibility = 'visible'
                        setTimeout(() => {
                            currentLine = 0
                            listElement.style.transition = ''
                            changeCountdownItem(currentLine, constantPauseBetweenLines + constantChangeTransitionTime)
                        },constantChangeTransitionTime) // min 20ms
                    }, constantPauseBetweenLines)

                }, +pauseBetweenLines + constantPauseBetweenLines)
                
            } else {
                setTimeout(() => {
                    if (typeof callback === 'function') {
                        callback()
                    } else {
                        console.error('callback() is not a function')
                    }
                },+delayOut)
            }
        }
    }
}

// function animateCredits({captionElement, callback, animationDirection, getAnimationIsActive = () => true, isInBox, slideMomentId}) {
//     const constantPauseBetweenLines = 400
//     const constantChangeTransitionTime = 50
//     let pauseBetweenLines = captionElement.getAttribute('data-pauseBetweenLines') || 0
//     // если капча находится вне бокса, то delayIn уже отсчитался при вызове текущей функции
//     const delayIn = isInBox ? captionElement.getAttribute('data-delayIn') : 0
//     const delayOut = isInBox ? captionElement.getAttribute('data-delayOut') : constantPauseBetweenLines
//     const isLoop = captionElement.getAttribute('data-loop') === 'true'
//     const isForwardDirection = captionElement.getAttribute('data-direction') === 'forward'
//     const creditsItems = captionElement.querySelectorAll('.credits-content')
//     console.log('animateCredits', captionElement, creditsItems)
//     // clearTimeout(creditsLinesTimeout)
//     // clearTimeout(creditsMainTimeout)
//     for (let item of creditsItems) {
//         if (isForwardDirection) {
//             item.classList.remove('playing-forward')
//         } else {
//             item.classList.remove('playing')
//         }
//     }
//     // if (slideMomentId !== currentSlideMomentId || !getAnimationIsActive()) {
//     //     clearTimeout(creditsLinesTimeout)
//     //     clearTimeout(creditsMainTimeout)
//     //     return
//     // }
    
//     let creditsLinesTimeout = setTimeout(() => {
//         for (let [index, item] of creditsItems.entries()) {
//             if (isForwardDirection) {
//                 item.classList.add('playing-forward')
//             } else {
//                 item.classList.add('playing')
//             }
//             item.style.animationDelay = `${index * 3 + (index * pauseBetweenLines) / 1000}s`


//         }
//     }, +delayIn)
    

//     let creditsMainTimeout = setTimeout(() => {
//         for (let item of creditsItems) {
//             if (isForwardDirection) {
//                 item.classList.remove('playing-forward')
//             } else {
//                 item.classList.remove('playing')
//             }
//         }
//         if (isLoop) {
//             setTimeout(() => {
//                 animateCredits({captionElement, callback, animationDirection, getAnimationIsActive, isInBox, slideMomentId})
//             }, 1)
            
//         } else {
//             clearInterval(checkTimeout)
//             if (typeof callback === 'function') {
//                 callback()
//             } else {
//                 console.error('callback() is not a function')
//             }
//         }
//     }, creditsItems.length * 3000 + (creditsItems.length - 1) * pauseBetweenLines)
//     let checkTimeout = setInterval(() => {
//         // console.log('checkTimeout', slideMomentId !== currentSlideMomentId, !getAnimationIsActive())

//         if (slideMomentId !== currentSlideMomentId || !getAnimationIsActive()) {
//             for (let item of creditsItems) {
//                 if (isForwardDirection) {
//                     item.classList.remove('playing-forward')
//                 } else {
//                     item.classList.remove('playing')
//                 }
//             }
//             clearTimeout(creditsLinesTimeout)
//             clearTimeout(creditsMainTimeout)
//             clearInterval(checkTimeout)
//             return
//         }
//     }, 300)
// }

function animateCredits({captionElement, callback, animationDirection, getAnimationIsActive = () => true, isInBox, slideMomentId}) {
    const constantPauseBetweenLines = 0
    const constantStayIn = 400
    const constantChangeTransitionTime = 50
    
    let pauseBetweenLines = captionElement.getAttribute('data-pauseBetweenLines') || 0
    // если капча находится вне бокса, то delayIn уже отсчитался при вызове текущей функции
    const delayIn = isInBox ? captionElement.getAttribute('data-delayIn') : 0
    // const delayOut = isInBox ? captionElement.getAttribute('data-delayOut') : constantPauseBetweenLines
    const delayOut = isInBox ? 0 : constantPauseBetweenLines
    const isLoop = captionElement.getAttribute('data-loop') === 'true'
    const isForwardDirection = captionElement.getAttribute('data-direction') === 'forward'
    let listItemElements = captionElement.querySelectorAll('.credits-content')
    // список
    // после анимации исчезновения переставляем список в первоначальное положение
    if (animationDirection === 'animationOut') {
        if (typeof callback === 'function') {
            for (let item of listItemElements) {
                item.style.transition = 'none'
                item.style.filter = ``
                item.style.opacity = ``
                item.style.transform = ``
            }
            for (let item of listItemElements) {
                item.style.transition = ``
            }
            callback()
        } else {
            console.error('callback() is not a function')
        }
        return
    }
    // for (let item of listItemElements) {
    //     item.style.opacity = `1`
    //     item.style.color = `rgba(255, 0, 0, 1)`
    // }
    let clonedFirstElem
    if (isLoop && listItemElements.length === 1) {
        // console.log('one')
        const listElementToClone = captionElement.querySelector('.credits-item-visible')
        clonedFirstElem = listElementToClone.cloneNode(true)
        captionElement.append(clonedFirstElem)
        listItemElements = captionElement.querySelectorAll('.credits-content')
    }

    // элементы списка
    const itemCount = listItemElements.length
    let currentLine = 0

    // если анимация зациклена, то добавляю в конец списка певрый элемент, чтобы был красивый переход между циклами
    setTimeout(() => {
        
        changeCountdownItem(currentLine)
    },+delayIn + constantChangeTransitionTime)

    function changeCountdownItem(currentLine, minusMS = 0) {
        // если слайд переключился, а анимация предназначения для предыдущего слайда, то останавливаем её
        if (slideMomentId !== currentSlideMomentId) {
            for (let item of listItemElements) {
                item.style.transition = 'none'
                item.style.filter = ``
                item.style.opacity = ``
                item.style.transform = ``
            }
            return
        }
        // проверка, воспроизводится ли превью, чтобы прекратить цикл в случае с loop = true
        if (!getAnimationIsActive()) {
            for (let item of listItemElements) {
                item.style.transition = 'none'
                item.style.filter = ``
                item.style.opacity = ``
                item.style.transform = ``
            }
            return
        }

        listItemElements[currentLine].style.transform = `scale(1)`
        listItemElements[currentLine].style.filter = `blur(0px)`
        listItemElements[currentLine].style.opacity = `1`
        currentLine++
        if (currentLine < itemCount) {
            setTimeout(() => {
                listItemElements[currentLine - 1].style.transform = isForwardDirection ? `scale(2)` : `scale(0)`
                listItemElements[currentLine - 1].style.filter = `blur(5px)`
                listItemElements[currentLine - 1].style.opacity = `0`
                setTimeout(() => {
                    listItemElements[currentLine - 1].style.transition = 'none'
                    listItemElements[currentLine - 1].style.filter = ``
                    listItemElements[currentLine - 1].style.opacity = ``
                    listItemElements[currentLine - 1].style.transform = ``
                    setTimeout(() => {
                        listItemElements[currentLine - 1].style.transition = ''
                    }, 0)
                }, 500)
            }, +constantStayIn + +pauseBetweenLines)  
            setTimeout(() => {
                changeCountdownItem(currentLine)
            }, +pauseBetweenLines + constantStayIn + constantPauseBetweenLines)
        } else {
            if (isLoop) {
                setTimeout(() => {
                    listItemElements[currentLine - 1].style.transform = isForwardDirection ? `scale(2)` : `scale(0)`
                    listItemElements[currentLine - 1].style.filter = `blur(5px)`
                    listItemElements[currentLine - 1].style.opacity = `0`
                    setTimeout(() => {
                        // for (let item of listItemElements) {
                        //     item.style.transition = 'none'
                        //     item.style.filter = ``
                        //     item.style.opacity = ``
                        //     item.style.transform = ``
                        // }
                        const currentLineCached = currentLine - 1
                        setTimeout(() => {
                            listItemElements[currentLineCached].style.transition = 'none'
                            listItemElements[currentLineCached].style.filter = ``
                            listItemElements[currentLineCached].style.opacity = ``
                            listItemElements[currentLineCached].style.transform = ``
                            setTimeout(() => {
                                listItemElements[currentLineCached].style.transition = ''
                            }, 0)
                        }, 500)
                        currentLine = 0
                        changeCountdownItem(currentLine)
                    }, 0)

                }, +pauseBetweenLines + constantStayIn + constantPauseBetweenLines)
                
            } else {
                setTimeout(() => {
                    if (typeof callback === 'function') {
                        callback()
                    } else {
                        console.error('callback() is not a function')
                    }
                },+delayOut + constantStayIn)
            }
        }
    }
}

// const library = {
//     hinge: {
//         duration: 2000,
//         keyframes: [
//             {
//                 start: 0,
//                 styles: {
//                     transformOrigin: 'top left'
//                 }
//             },
//             {
//                 start: 20,
//                 styles: {
//                     transition: 'all 0.4s ease-in-out',
//                     transform: 'rotate(80deg)',
//                     transformOrigin: 'top left'
//                 }
//             },
//             {
//                 start: 40,
//                 styles: {
//                     transition: 'all 0.4s ease-in-out',
//                     transform: 'rotate(60deg)'
//                 }
//             },
//             {
//                 start: 60,
//                 styles: {
//                     transform: 'rotate(80deg)'
//                 }
//             },
//             {
//                 start: 80,
//                 styles: {
//                     transform: 'rotate(60deg)'
//                 }
//             },
//             {
//                 start: 100,
//                 styles: {
//                     transform: 'translateY(700px)',
//                     opacity: 0
//                 }
//             },
//         ],
//         reset: {
//             transform: 'none',
//             transition: 'none',
//             transformOrigin: 'center'
//         }
//     },
//     bounceInDown: {
//         duration: 1000,
//         keyframes: [
//             {
//                 start: 0,
//                 styles: {
//                     transition: 'none',
//                     opacity: 0,
//                     transform: 'translateY(-3000px)'
//                 }
//             },
//             {
//                 start: 60,
//                 styles: {
//                     animationTimingFunction: 'cubic-bezier(.215, .61, .355, 1)',
//                     transitionProperty: 'all',
//                     opacity: 1,
//                     transform: 'translateY(25px)',
//                 }
//             },
//             {
//                 start: 74,
//                 styles: {
//                     transform: 'translateY(-10px)'
//                 }
//             },
//             {
//                 start: 90,
//                 styles: {
//                     transform: 'translateY(5px)'
//                 }
//             },
//             {
//                 start: 100,
//                 styles: {
//                     transform: 'translateY(0)',
//                 }
//             },
//         ],
//         reset: {
//             transform: 'none',
//             transition: 'none',
//             animationTimingFunction: 'linear'
//         }
//     }
// }

// function keyframeAnimation(visibleNodeElement, animationObj, keyFrameIndex, callback) {

//     const stylesObj = animationObj.keyframes[keyFrameIndex].styles

    
//     const frameDuration = keyFrameIndex ? (animationObj.keyframes[keyFrameIndex].start - animationObj.keyframes[keyFrameIndex - 1].start) * animationObj.duration / 100 : 50
//     visibleNodeElement.style.transitionDuration = `${frameDuration}ms`
    
//     for (const styleName in stylesObj) {
//         visibleNodeElement.style[styleName] = stylesObj[styleName]
//     }
//     // console.log('frameDuration',frameDuration,'animationObj.keyframes[keyFrameIndex].start',animationObj.keyframes[keyFrameIndex].start)
    
//     setTimeout(() => {
//         // если следующий кейфрейм есть - запускаем его, если нет - вызываем колбек завершения анимации
//         if (animationObj.keyframes[keyFrameIndex + 1]) {
//             keyframeAnimation(visibleNodeElement, animationObj, keyFrameIndex + 1, callback)
//         } else {
//             for (const styleName in animationObj.reset) {
//                 visibleNodeElement.style[styleName] = animationObj.reset[styleName]
//             }
//             if (typeof callback === 'function') callback()
//         }
//     }, frameDuration)
// }


// function animateCSS(element, animationConfig, captionClassName, callback, unicClassName) {
//     // для тогдо, чтобы в редакторе при выходе из режима демонстрации анимации капчи больше не проигрывались
//     if (unicClassName && !document.querySelector(`.${captionClassName}`)) {
//         console.log('animateCSS return')
//         return
//     } 

//     let node = document.querySelectorAll(element)

//     let visibleNodeElement

//     for (let i = 0; i < node.length; i++) {
//         if (!node[i].parentElement.parentElement.matches('.clone')) {
//             visibleNodeElement = node[i]
//         }
//     }

//     const animationObj = library[animationConfig]


//     keyframeAnimation(visibleNodeElement, animationObj, 0, callback)


// }